/**
 * inverses a given 2d-array
 */
export const inverseMatrix = <T extends {}>(matrix: T[][]): T[][] => {
  return matrix[0].map((col, c) => matrix.map((row, r) => matrix[r][c]));
};
